import {
  AppData,
  CalcMode,
  Calculator,
} from "../../interface/functionalityInterface";
import { Area } from "../baseQuantities/area";
import { Power } from "../baseQuantities/power";
import { Temperature } from "../baseQuantities/temperature";
import { uValue } from "../baseQuantities/uValue";

const standardMode: CalcMode = {
  id: "001standard",
  name: "standard",
  baseQuantities: [
    { ...Power },
    { ...uValue },
    { ...Area },
    { ...Temperature, name: "inner_temp", symbol: "Ti" },
    { ...Temperature, name: "outer_temp", symbol: "To" },
  ],
  equation: "P=U*A(T\u1D62-T\u2080)",
};

export const heatLossCalc: Calculator = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-07-26",
  name: "heat loss",
  branch: "Thermal",
  difficulty: "intermediate",
  inputs: [standardMode],
  calculate: [
    {
      name: "standard",
      equations: [
        {
          target: "power",
          expression: "(u-value) * (area) * ((inner_temp) - (outer_temp))",
        },
        {
          target: "u-value",
          expression: "(power) / (area) / ((inner_temp) - (outer_temp))",
        },
        {
          target: "area",
          expression: "(power) / (u-value) / ((inner_temp) - (outer_temp))",
        },
        {
          target: "inner_temp",
          expression: "(power) / (u-value) / (area) + (outer_temp)",
        },
        {
          target: "outer_temp",
          expression: "(inner_temp) - (power) / (u-value) / (area)",
        },
      ],
    },
  ],
};
